import { INavigationStep } from 'types/navigation';

/**
 * Creates a unique key for module components that includes navigation path
 * This ensures modules remount when navigation changes
 *
 * @param modulePrefix - The module name (e.g., 'trainer', 'book')
 * @param courseId - The course ID
 * @param search - The search parameter (usually entity ID)
 * @param navigationPath - The hierarchical navigation path
 * @returns A unique key string
 */
export function createModuleNavigationKey(
  modulePrefix: string,
  courseId: number,
  search?: string,
  navigationPath?: INavigationStep[],
): string {
  const navigationKey = navigationPath?.map((n) => `${n.ref}-${n.refId}`).join('-') || '';
  return `${modulePrefix}-${courseId}-${search || ''}-${navigationKey}`;
}
